'use client';

import React from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppTheme } from '@shared/theme/ThemeProvider';

interface LoadingOverlayProps {
  visible: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ visible, message }) => {
  const { t } = useTranslation();
  const theme = useAppTheme();
  const label = message ?? t('common.loading') ?? '???';

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-max flex items-center justify-center px-4"
      style={{ backgroundColor: theme.colors.ui.overlay }}
      role="alertdialog"
      aria-busy="true"
      aria-label={label}
    >
      <div
        className="flex min-w-[200px] flex-col items-center gap-3 rounded-lg px-6 py-5"
        style={{
          backgroundColor: theme.colors.surface,
          border: `1px solid ${theme.colors.border}`,
        }}
      >
        <Loader2
          className="size-8 animate-spin"
          style={{ color: theme.colors.accent }}
          aria-hidden
        />
        <p className="text-sm font-medium" style={{ color: theme.colors.textPrimary }}>
          {label}
        </p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
